import { render, staticRenderFns } from "./menu-home.vue?vue&type=template&id=1e472daa&"
import script from "./menu-home.vue?vue&type=script&lang=ts&"
export * from "./menu-home.vue?vue&type=script&lang=ts&"
import style0 from "./menu-home.vue?vue&type=style&index=0&id=1e472daa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports